<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('information.notice.notice_details.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('information.title') }} > </span>
          <span class="middle_loc">{{ $t('information.notice.title') }} > </span>
          <span class="back_loc">{{ $t('common.common.view') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">
          <div class="board__re__view">
            <div class="board__re__header">
              <div class="numb__title">
                <div class="numb">No.{{ seq }}</div>
                <div class="title" v-if="$vuetify.rtl" >{{ viewNotice.subject_ar }}</div>
                <div class="title" v-if="!$vuetify.rtl" >{{ viewNotice.subject_en ? viewNotice.subject_en : viewNotice.subject_ar }}</div>
              </div>

              <div class="date">
                <a icon class="attach__mt ty2" v-if="getFileAttachShowYn($vuetify.rtl ? viewNotice.attached_ar_file_key:viewNotice.attached_en_file_key)"
                  :href="downLoadUrl + ($vuetify.rtl ? viewNotice.attached_ar_file_key : viewNotice.attached_en_file_key)">
                  <!-- origin source
                    <v-icon>{{ getExtIcon($vuetify.rtl ? viewNotice.attached_ar_file_ext : viewNotice.attached_en_file_ext) }}</v-icon>
                  -->

                  <!-- 디자인 변경으로 첨부파일 아이콘 하나로 통일 -->
                  <v-icon color="#a01c2a" class="attach__mt__icon">mdi-email</v-icon>
                  <v-icon color="#fff" class="inner_icon">mdi-paperclip</v-icon>
                </a>

                <span class="bar" v-if="getFileAttachShowYn($vuetify.rtl ? viewNotice.attached_ar_file_key:viewNotice.attached_en_file_key)">|</span>
                <v-icon>mdi-calendar</v-icon>
                <v-spacer class="hidden_lr5"></v-spacer>
                {{ viewNotice.write_date }}
                <span class="bar">|</span>
                <v-icon>mdi-eye</v-icon>
                <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                {{ viewNotice.read_count }}
              </div>
            </div>
            <div class="answ__content ty2">
              <div v-html="$vuetify.rtl ? viewNotice.content_ar : viewNotice.content_en" style="min-height: 300px"></div>
            </div>
          </div>

          <v-row class="board_views ma-0">
            <v-col cols="12" class="pa-0">
              <v-row>
                <v-col cols="12" class="d-flex pa-0 mt-20">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#acb0b3"
                    dark
                    min-width="150"
                    min-height="50"
                    class="btn-normal br_none"
                    @click="fnGoList()"
                  >
                    {{ $t('common.button.go_to_list') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  name : 'NoticeView',
  components :{
  },
  data () {
    return {
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',

      seq : this.$route.params.seq,

      viewNotice : {
        subject_ar : '',
        subject_en : '',
        content_ar : '',
        content_en : '',
        attached_en_file_key : '',
        attached_en_file_name : '',
        attached_en_file_ext: '',
        attached_ar_file_key : '',
        attached_ar_file_name : '',
        attached_ar_file_ext: '',
        seq : null,
        write_date : '',
        read_count : 0
      },
    }
  },
  created () {
    // 잘못된 접근
    if(utils.isNull(this.$route.params.seq)){
      this.$router.go(-1)
    }

    this.fnGetNoticeView()
  },
  mounted(){
    window.scrollTo(0, 0)
  },
  methods: {
    fnGetNoticeView(){
      requestApi({
        url: '/info/notices/' + this.seq,
        method: 'GET',
        callback: (res) => {

          if (res.res_code === '200') {
            this.viewNotice.seq = res.data.seq
            this.viewNotice.subject_ar = res.data.subject_ar
            this.viewNotice.subject_en = res.data.subject_en
            this.viewNotice.content_ar = res.data.content_ar
            this.viewNotice.content_en = res.data.content_en
            this.viewNotice.attached_en_file_key = res.data.attached_en_file_key
            this.viewNotice.attached_en_file_name = res.data.attached_en_file_name
            this.viewNotice.attached_en_file_ext = res.data.attached_en_file_ext
            this.viewNotice.attached_ar_file_key = res.data.attached_ar_file_key
            this.viewNotice.attached_ar_file_name = res.data.attached_ar_file_name
            this.viewNotice.attached_ar_file_ext = res.data.attached_ar_file_ext
            this.viewNotice.write_date =  utils.replaceAll(res.data.write_date, '-', '/')
            this.viewNotice.read_count = res.data.read_count
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetNoticeView()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    getFileAttachShowYn(fileKey){
      return !utils.isNull(fileKey)
    },
    fnGoList(){

      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push("/information/notice?" + qryStr)
    },
    getExtIcon(fileExt){
      let ext = fileExt.toLowerCase()
      if(ext == 'doc' || ext == 'docx'){
        return 'mdi-file-word'
      }else if(ext == 'xlsx' || ext == 'xls'){
        return 'mdi-file-excel'
      }else if(ext == 'ppt' || ext == 'pptx'){
        return 'mdi-file-ppt'
      }else if(ext == 'pdf'){
        return 'mdi-file-pdf'
      }else if(ext == 'png' || ext == 'bmp' || ext == 'rle' || ext == 'dib' ||ext == 'gif' || ext == 'tif' || ext == 'tiff' || ext == 'jpg' ){
        return 'mdi-file-image'
      //}else if(ext == 'txt'){
      //  return 'text-box-outline'
      }else{
        return 'mdi-paperclip'
      }
    },

  },
}
</script>